import { getOrderDetail, getUserSummary } from 'helpers/api';
import { getUrlParamsByName, formatMoney, hideCartIcon, getWarehouseLocation } from 'helpers/utils';
import { isProd } from 'config/config';

import Vue from 'vue/dist/vue';

const orderConfirmationEl = document.querySelector('#order-confirmation');
if (orderConfirmationEl) {
    new Vue({
        el: '#order-confirmation',
        data: {
            orders: [],
            userSummary: null,
            isLoading: true,
        },
        computed: {
            isProd: function () {
                return isProd;
            },
        },
        filters: {
            formatMoney: function (price) {
                return formatMoney(price);
            },
            orderReviewURL: function (orderNumber) {
                return isProd
                    ? '/portal/order-details?orderNumber=' + orderNumber
                    : '/order-details.html?orderNumber=' + orderNumber;
            },
            getShippingWarehouse: function (code) {
                return getWarehouseLocation(code);
            },
        },
        methods: {
            setValues: async function () {
                const orderNumber = getUrlParamsByName('orderNumber');

                getOrderDetail(orderNumber).then((response) => {
                    this.orders.push(response.data);
                    if (this.orders[0].OtherTicketList.length) {
                        this.orders[0].OtherTicketList.forEach((orderNum) => {
                            getOrderDetail(orderNum).then((response) => {
                                this.orders.push(response.data);
                            });
                        });
                    }
                });

                getUserSummary().then((response) => {
                    this.userSummary = response.data;
                });

                this.isLoading = false;
            },
        },
        created() {
            this.setValues();
        },
    });
}

function init() {
    hideCartIcon();
}

export default init;
